import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSafeId } from 'site-modules/shared/hooks/use-safe-id';
import { SCROLL_OFFSET } from 'site-modules/shared/constants/sub-navigation';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';

export function RatingScorecardEmbed({ children = null, childrenClassName = null, isEmbed = true }) {
  const id = `scorecard-embed-${useSafeId()}`;

  return (
    !!children && (
      <Fragment>
        {isEmbed && (
          <Fragment>
            <ScrollLink
              className="scorecard-embed-scroll-link rounded"
              to={id}
              scrollConfig={{ offset: SCROLL_OFFSET }}
              data-tracking-id="continue_reading"
            >
              <em className="d-inline-block mt-1 mb-2 medium text-gray-darker">
                <i className="icon-arrow-down8 small me-0_5" aria-hidden />
                Continue reading Edmunds Expert Rating below
              </em>
            </ScrollLink>
          </Fragment>
        )}
        <div className={childrenClassName}>{children}</div>
        <ScrollElement id={id} />
      </Fragment>
    )
  );
}

RatingScorecardEmbed.propTypes = {
  children: PropTypes.node,
  childrenClassName: PropTypes.string,
  isEmbed: PropTypes.bool,
};
